import { LayoutServiceData } from "@sitecore-jss/sitecore-jss-nextjs";

interface PageMeta {
  title: string;
  description?: string;
}

/**
 * Extracts meta title and description from Sitecore layout data
 * @param layoutData - Sitecore layout service data
 * @returns Object containing title and description for meta tags
 */
export const getPageMeta = (layoutData: LayoutServiceData): PageMeta => {
  if (!layoutData) {
    return { title: "Topshop" };
  }

  const route = layoutData?.sitecore?.route;
  const fields = route?.fields;

  let title = "";
  let description = "";

  if (fields?.metaTitle && "value" in fields.metaTitle) {
    title = fields.metaTitle.value as string;
  }

  if (fields?.metaDescription && "value" in fields.metaDescription) {
    description = fields.metaDescription.value as string;
  }

  return {
    title: title || "Topshop",
    description,
  };
};
